import {ENV} from "../../constant/ENV";
import {config} from "../config";

interface GoogleConfigPublic {
    recaptcha: {
        url: string
        publicKey: string
    }
}

let googleConfigPublic: GoogleConfigPublic

if (config.env === ENV.PRODUCTION) {
    googleConfigPublic = {
        recaptcha: {
            url: `https://www.google.com/recaptcha/api.js`,
            publicKey: `6Lf44ZkcAAAAANA9Ms8idIz7pUpT-tx0qVU0qMiT`
        },
    }
} else if (config.env === ENV.DEVELOPMENT) {
    googleConfigPublic = {
        recaptcha: {
            url: `https://www.google.com/recaptcha/api.js`,
            publicKey: `6LcerKcUAAAAAIG5kXqqLOEpdIvGKOSiDi1poJTr`
        },
    }
}

export {googleConfigPublic}
